'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the showing a finger touching gesture inviting
 * the user to swipe or touch the screen.
 */
export function FingerTouchGesturesAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import(
      '../raw-json/functional-assessment/gestures/finger-touch-gestures.json'
    );

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="FingerTouchGesturesAnimation"
    />
  );
}
